module.exports = __webpack_public_path__ + "static/media/IMG_4873.caead2c9.JPG";